/**
 * Who counts as a Peak user, which decides the landing page after login:
 * Peak → /stats, Summit (everyone else) → /.
 *
 * CommonJS (not ESM) so it can be unit-tested with the node-backend test
 * harness; Babel's interop lets the React components `import` it.
 */

var PEAK_USER_EMAIL_DOMAIN = '@peakcapital.com';

/** TEAM.IS_AGENT role codes, mirroring frontend/src/roles.js. */
var ROLE_PEAK_AGENT = 'p';
var ROLE_PEAK_EMPLOYEE = 'q';

/** True when the email is on the Peak Capital domain. */
function isPeakUserEmail(email) {
    if (email == null || email === '') return false;
    return String(email).trim().toLowerCase().endsWith(PEAK_USER_EMAIL_DOMAIN);
}

/** True when the Role is Peak - Agent or Peak - Employee. */
function isPeakUserRole(role) {
    if (role == null || role === '') return false;
    var code = String(role).trim().toLowerCase();
    return code === ROLE_PEAK_AGENT || code === ROLE_PEAK_EMPLOYEE;
}

/** A user is Peak if EITHER the email domain or the Role says so. */
function isPeakUser(email, role) {
    return isPeakUserEmail(email) || isPeakUserRole(role);
}

module.exports = {
    isPeakUser: isPeakUser,
    isPeakUserEmail: isPeakUserEmail,
    isPeakUserRole: isPeakUserRole,
    PEAK_USER_EMAIL_DOMAIN: PEAK_USER_EMAIL_DOMAIN,
    ROLE_PEAK_AGENT: ROLE_PEAK_AGENT,
    ROLE_PEAK_EMPLOYEE: ROLE_PEAK_EMPLOYEE,
};
